/**
 * Config runtime per-host (B9 — frontend domain-agnostic).
 *
 * Le URL non sono più incise nel bundle a build-time: vengono lette da
 * `window.__LEXMED_RUNTIME__`, popolato da /runtime-config.js che il
 * container nginx genera all'avvio dalle env REACT_APP_* (vedi
 * docker-entrypoint.nginx.sh). Così la STESSA immagine portal serve
 * qualunque host/dominio (pull dal registry, niente build in loco).
 *
 * Ordine di risoluzione per ogni chiave:
 *   1. window.__LEXMED_RUNTIME__ (runtime, per-host)
 *   2. process.env.REACT_APP_*   (build-time: dev server, build IP-mode)
 *   3. default localhost         (stack locale non containerizzato)
 */
const runtime =
  (typeof window !== 'undefined' && window.__LEXMED_RUNTIME__) || {}

export function pick(key, buildValue, fallback) {
  const v = runtime[key]
  if (typeof v === 'string' && v.trim() !== '') return v
  if (typeof buildValue === 'string' && buildValue.trim() !== '') {
    return buildValue
  }
  return fallback
}

// Il default localhost sta DENTRO l'`||` con la env di build, non come terzo
// argomento di pick(): CRA sostituisce process.env.REACT_APP_SERVER_URL con la
// stringa di produzione e il minifier elimina il ramo morto, cosi' l'URL di
// sviluppo non arriva nel bundle servito. Passato a pick() restava nel bundle
// e il guardrail della CI (build:image) bloccava il tag v1.9.0.
export const SERVER_URL = pick(
  'SERVER_URL',
  process.env.REACT_APP_SERVER_URL || 'http://127.0.0.1:9100/api',
  ''
)

export const DEFAULT_LEARES_URL = pick(
  'DEFAULT_LEARES_URL',
  process.env.REACT_APP_DEFAULT_LEARES_URL,
  // Vuoto, non localhost: senza VM assegnata la dashboard deve mostrare
  // "nessuna VM", non rimandare l'utente a un indirizzo che non esiste.
  ''
)

export const PROD_MODE_ENABLED = pick(
  'PROD_MODE_ENABLED',
  process.env.REACT_APP_PROD_MODE_ENABLED,
  '0'
)

export const SENTRY_DSN = pick(
  'SENTRY_DSN',
  process.env.REACT_APP_SENTRY_DSN,
  ''
)
